import { render } from "./ChatRecipe.vue?vue&type=template&id=5a9d90d6&scoped=true"
import script from "./ChatRecipe.vue?vue&type=script&lang=js"
export * from "./ChatRecipe.vue?vue&type=script&lang=js"

import "./ChatRecipe.vue?vue&type=style&index=0&id=5a9d90d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9d90d6"]])

export default __exports__